/**
 * Erkennt Tickets ohne echte Kundenzuordnung — sowohl den Fall „kein partyName"
 * als auch den KIAN-Platzhalter „--- Kunde zuordnen ---" (eine echte Weclapp-Party
 * mit partyId, deren Name signalisiert, dass noch kein Kunde zugeordnet ist).
 *
 * Muss zum serverseitigen Filter (CUSTOMER_PLACEHOLDER_MARKER in
 * backend/src/services/weclappMirror.ts) konsistent bleiben.
 */
export function isCustomerMissing(partyName?: string | null): boolean {
  if (!partyName || !partyName.trim()) return true;
  return /kunde zuordnen/i.test(partyName);
}

/**
 * Anzeigename inkl. Kundennummer — „Name (12345)".
 * In allen Kunden-Auswahlfeldern verwenden, damit Techniker sich auf die
 * Kundennummer beziehen können und danach suchbar bleibt.
 */
export function customerLabel(name: string, customerNumber?: string | null): string {
  return customerNumber ? `${name} (${customerNumber})` : name;
}
